import React from "react";
import { assets } from "../../../Assets/assets";
import LabelHeading from "../../common/LabelHeading";

const Director = ({ id }) => {
  return (
    <section id={id} className="w-full bg-[#F3F4FB]">
      <div className="max-w-[1400px] mx-auto px-6 xl:py-20 py-14 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

        <div data-aos="fade-up-right" data-aos-duration="1000" className="space-y-6 font-DmSans">

          <LabelHeading label={'words of Chairpersons'} heading={'Director’s Words'} text={'That’s why the highly skilled and dedicated recruitment team at Natio Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients. We focus on helping our employees achieve their career goals while delivering effective staffing solutions tailored to the needs of our clients and candidates.'} position={'left'} />

          <div className="flex gap-4">
            <div className="w-4 bg-primaryFadedColor"></div>
            <p className="font-semibold text-primaryTextColor  leading-relaxed">
              We understand that attracting, qualifying, placing, and retaining the best
              candidates for our clients requires exceptional talent.
            </p>
          </div>

          <p className="text-secondaryTextColor leading-relaxed">
            That’s why the highly skilled and dedicated recruitment team at Natio Management Services Private Limited works tirelessly to build long-term relationships with both candidates and clients. We focus on helping our employees achieve their career goals while delivering effective staffing solutions tailored to the needs of our clients and candidates.
          </p>
        </div>

        <div data-aos="fade-up-left" data-aos-duration="1000" className="relative flex justify-center">
          <img
            src={assets.directorimg}
            alt="Director"
            className="rounded-lg shadow-xl w-full h-[30rem] object-cover"
          />

          <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 lg:left-auto lg:translate-x-0 lg:-bottom-6 lg:right-8 w-[260px] md:w-[300px] bg-white shadow-lg rounded-xl p-5 text-center lg:text-left">
            <h3 className="text-xl font-semibold text-primaryNavyTextColor font-SpaceGrotesk">
              Devid Warner
            </h3>
            <p className="text-secondaryTextColor text-sm">Senior Developer</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Director;
